export default "__VITE_ASSET__BcXAWmF1__"